var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("Hello "+_vm._s(_vm.value))]),_c('div',[_vm._v("UserData "+_vm._s(_vm.user))]),_c('div',[_vm._v("API "+_vm._s(_vm.apiresponse))]),_c('input',{attrs:{"type":"button","value":"メッセージを取得"},on:{"click":_vm.getData}})])}
var staticRenderFns = []

export { render, staticRenderFns }